import { MenuItem } from "@/client";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { cn } from "@/utils";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { renderNavigationItemForm } from "./render-navigation-item-form";

type SortableNavigationItemProps = {
  item: MenuItem;
  menuId: string;
  onClose: () => void;
  disabled?: boolean;
};

function SortableNavigationItem({
  item,
  disabled,
  onClose,
  menuId,
}: SortableNavigationItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id, disabled: disabled });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <AccordionItem
        value={item.id}
        key={item.id}
        // dont let play with toggling if we clicked "new menu item" plus button
        disabled={disabled}
      >
        <div className="flex items-center justify-between">
          <div
            {...attributes}
            {...listeners}
            className={cn(
              "flex cursor-default items-center px-2",
              !disabled && "cursor-move",
            )}
          >
            {item.icon ? (
              <span className="material-icons mr-1.5 text-foreground">
                {item.icon.replaceAll("-", "_")}
              </span>
            ) : (
              <span className="mr-2 w-2" />
            )}
            {item.title}
          </div>
          <AccordionTrigger>
            <span className="ml-auto mr-2 text-sm lowercase text-muted-foreground">
              {item.type.replaceAll("_", " ")}
            </span>
          </AccordionTrigger>
        </div>
        <AccordionContent>
          {renderNavigationItemForm({
            menuId: menuId,
            menuItemType: item.type,
            menuItem: item,
            onClose,
          })}
        </AccordionContent>
      </AccordionItem>
    </div>
  );
}

export { SortableNavigationItem };
